class Common {
  constructor() {
    this.searchbtn = document.querySelector(".search-btn");
    this.btn = document.getElementById("shareEventBtn");
    this.popover = document.getElementById("sharePopover");
    this.copyBtn = document.getElementById("copyEventLink");
    this.popoverWrapper = document.getElementById("popover-wrapper");

    this.toast = document.querySelector('[role="status"]');
    this.toastClose = document.querySelector("[toast-close]");

    // ensure hidden on load
    if (this.toast) {
      this.toast.setAttribute("data-state", "closed");
    }

    this.AllEvent();
  }

  showToast() {
  if (!this.toast) return;

  this.toast.classList.remove("toast-init"); // important
  this.toast.setAttribute("data-state", "open");
  this.popoverWrapper.classList.remove("-z-[1]");
  this.popoverWrapper.classList.add("z-[100]");
  
  clearTimeout(this.toastTimer);
  this.toastTimer = setTimeout(() => {
    this.hideToast();
  }, 3000);
}

  hideToast() {
    if (!this.toast) return;
    this.toast.setAttribute("data-state", "closed");
    this.popoverWrapper.classList.add("-z-[1]");
    this.popoverWrapper.classList.remove("z-[100]");
  }

  AllEvent() {
    // Share Popover
    if (this.btn && this.popover) {
      this.btn.addEventListener("click", (e) => {
        e.stopPropagation();
        this.popover.classList.toggle("hidden");
      });

      document.addEventListener("click", (e) => {
        if (!this.popover.contains(e.target) && e.target !== this.btn) {
          this.popover.classList.add("hidden");
        }
      });
    }

    // Copy link
    if (this.copyBtn) {
      this.copyBtn.addEventListener("click", async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          this.showToast();
        } catch (err) {
          console.error("Copy failed", err);
        }
      });
    }

    // Close toast manually
    if (this.toastClose) {
      this.toastClose.addEventListener("click", () => {
        this.hideToast();
      });
    }

    if (this.searchbtn) {
      this.searchbtn.addEventListener("click", () => {
        this.searchbtn.closest("form").submit();
      });
    }

    gform.addFilter(
      "gform_datepicker_options_pre_init",
      function (options, formId, fieldId) {
        if (formId == 2 && (fieldId == 9 || fieldId == 11)) {
          options.minDate = 0;
        }
        return options;
      }
    );
  }
}

export default Common;